export default "assets/images/logo-8e92a73b.png";